const data = [
  {
    title: "Tic Tac Toe",
    shortDescription:
      "The classic 'X' vs 'O' game. The first player to get 3 in a row wins.",
    description:
      "This project teaches you how to think like a Referee. We create a board using an array of 9 empty boxes (`[null, null, ...]`). Every time a player clicks a box, we update that specific spot to 'X' or 'O'. The real challenge here is writing the 'Winning Logic'. After every single move, the code must instantly check 8 specific patterns (3 horizontal rows, 3 vertical columns, and 2 diagonals) to see if anyone has won. It's a perfect exercise in array logic.",
  },
];

export default data;